import Style from "./style"

import useSpinnerAtom from "shared/model/useSpinnerAtom"

const Spinner = () => {

    const [, , closeSpinnerEvent] = useSpinnerAtom()

    return (
        <Style.Wrapper onClick={closeSpinnerEvent}>
            <Style.Spinner />
        </Style.Wrapper>
    )
}

export default Spinner